var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3432 2.89344L11.3433 2.89353L11.3492 2.88631C11.6039 2.57499 12.0666 2.53482 12.398 2.80595C12.7159 3.06606 12.7399 3.52281 12.4875 3.80323L12.4875 3.80316L12.4824 3.80907L9.1319 7.73177L9.06001 7.81593V7.92661V16.5892C9.06001 17.029 8.71159 17.3516 8.29765 17.3516C7.85794 17.3516 7.53529 17.0032 7.53529 16.5892V12.1353V11.8353H7.23529H5.72347H5.42347V12.1353V16.5892C5.42347 17.0032 5.10082 17.3516 4.66111 17.3516C4.22139 17.3516 3.89875 17.0032 3.89875 16.5892V7.92661V7.81593L3.82686 7.73177L0.478559 3.81167C0.209478 3.48045 0.25017 3.01923 0.56078 2.76509C0.892143 2.49396 1.35486 2.53412 1.60958 2.84545L1.60951 2.84551L1.61421 2.85098L4.10668 5.75215L4.10667 5.75216L4.10845 5.7542C4.45063 6.14527 4.90025 6.34699 5.39659 6.34699H7.56217C8.04039 6.34699 8.54354 6.15744 8.85751 5.74594L11.3432 2.89344Z",
    stroke: "#189FAA",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73149 2.53341C8.73149 3.7669 7.73159 4.76682 6.49817 4.76682C5.26475 4.76682 4.26484 3.7669 4.26484 2.53341C4.26484 1.29992 5.26475 0.3 6.49817 0.3C7.73159 0.3 8.73149 1.29992 8.73149 2.53341Z",
    stroke: "#189FAA",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenter);
export default __webpack_public_path__ + "static/media/genter.ed2f7806684f7d2080a2ee58bda0f433.svg";
export { ForwardRef as ReactComponent };